



    export function loadImageHelper(url: string): Promise<string> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = function () {
                resolve(img.src);
            };
            img.onerror = function () {
                reject(new Error('Ocorreu um erro ao carregar a imagem.'));
            };
        });
    }